import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRepeat, faShuffle } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import {
  faBackwardStep,
  faForwardStep,
  faPause,
  faPlay,
} from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

import { toNextTrack, toPrevTrack, useAudioController } from '@store/audio/AudioController';
import { togglePlayPause } from '@store/audio/AudioEngineHTML5';
import { cycleRepeatMode, RepeatMode } from '@store/audio/AudioMeta';
import { toggleShuffleEnabled } from '@store/audio/AudioQueue';

export const ControlButtons = () => {
  const {
    isNextTrackDisabled,
    playing,
    loading,
    loadingActiveTrack,
    repeatMode,
    shuffleEnabled,
    disableNextPrev,
  } = useAudioController();

  return (
    <>
      <IconButton
        className="data-[state=active]:text-fuchsia500 data-[state=inactive]:text-black "
        onClick={toggleShuffleEnabled}
        data-state={shuffleEnabled ? 'active' : 'inactive'}
        icon={<FontAwesomeIcon icon={faShuffle} size="lg" />}
        title="Shuffle"
      />
      <IconButton
        className="text-black focus:text-black hover:text-black active:text-black "
        onClick={toPrevTrack}
        icon={<FontAwesomeIcon icon={faBackwardStep} size="lg" />}
        disabled={loading || loadingActiveTrack || disableNextPrev}
        title="Previous track"
      />
      <IconButton
        className="text-black focus:text-black hover:text-black active:text-black "
        disabled={loading || loadingActiveTrack}
        onClick={togglePlayPause}
        icon={<FontAwesomeIcon icon={playing ? faPause : faPlay} size="xl" />}
        title={playing ? 'Pause' : 'Play'}
        css={{ height: 24, width: 24 }}
      />
      <IconButton
        className="text-black focus:text-black hover:text-black active:text-black "
        disabled={isNextTrackDisabled || loading || loadingActiveTrack || disableNextPrev}
        onClick={toNextTrack}
        icon={<FontAwesomeIcon icon={faForwardStep} size="lg" />}
        title="Next track"
      />
      <div className="relative block">
        <IconButton
          className="data-[state=active]:text-fuchsia500 data-[state=inactive]:text-black "
          onClick={cycleRepeatMode}
          data-state={repeatMode !== RepeatMode.NO_REPEAT ? 'active' : 'inactive'}
          icon={<FontAwesomeIcon icon={faRepeat} size="lg" />}
          title="Repeat"
        />
        {repeatMode === RepeatMode.REPEAT_ONE && (
          <div className="absolute right-0.5 top-[3px] flex h-3 w-3 flex-shrink-0 select-none items-center justify-center rounded-full bg-black text-center leading-[10px]">
            <span className="w-full font-base text-[8px] font-extrabold text-white">1</span>
          </div>
        )}
      </div>
    </>
  );
};
